import React from 'react';
import { Espin_Event, MyEventsCardPlayerFragment } from '../../../generated/spin-graphql';
import { gql } from '@urql/core';
import { MyEventsCardFragment } from '../../../generated/spin-graphql';
import { EventCard } from '../../events/card/EventCard';
import { ExploreEventsCard } from './ExploreEventsCard';
import { PictureWithFallback } from '../../sections/PictureWithFallback';

type Props = {
    player?: MyEventsCardPlayerFragment;
    events: MyEventsCardFragment[];
};

gql`
    fragment MyEventsCard on espin_event {
        ...EventCard
    }

    fragment MyEventsCardPlayer on espin_player_profile {
        profile_image {
            ...SpinContentImageDisplay
        }
        spin_username
    }
`;

export const MyEventsCard: React.FC<Props> = ({ player, events }) => {
    const exploreEventsCardClassName = events.length % 3 === 0 ? '' : 'span-1';
    return (
        <div className="my-events-card">
            <div className="title-container">
                {player && (
                    <div className="image-wrapper">
                        <PictureWithFallback
                            icon={player.profile_image}
                            width={40}
                            height={40}
                            alt={`${player.spin_username} profile image`}
                        />
                    </div>
                )}
                <h2 className="title">{`${player ? player.spin_username : 'My Events'}`}</h2>
            </div>
            <div className="content">
                {events.map((event: Espin_Event, index: number) => (
                    <EventCard key={`upcoming-event-card-${index}`} event={event} isRegistered={true} />
                ))}
                <ExploreEventsCard className={exploreEventsCardClassName} />
            </div>
        </div>
    );
};
